// React
import React from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';

// Third party
import { useParams } from 'react-router-dom';

// Taxonomies
import {
  salesChannelCore,
  salesChannelDetail
} from '../../../taxonomies/salesChannel';

// This component
export default function SalesChannelDetail() {
  const { itemId } = useParams();
  const isNewItem = itemId === 'new';

  // Taxonomies
  const { endpoint, getDetailId, getDetailHash } = salesChannelCore();
  const { baseUrl, getInputs} = salesChannelDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'sales-channel',
        title: 'Sales Channel',
        // Static
        itemId,
        isNewItem,
        endpoint,
        baseUrl,
        getDetailId,
        getDetailHash,
        getInputs,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper type="salesChannel"/>
    </DetailContext.Provider>
  );
}
